export default function AuthorSection() {
  return (
    <section id="author" className="py-20 md:py-28 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="bg-white rounded-2xl p-6 md:p-10 flex flex-col md:flex-row gap-6 md:gap-10 items-center md:items-start">
          {/* Photo */}
          <div className="flex-shrink-0">
            <img
              src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/61a59271a80ff4d07ef88e35462987b3.png"
              alt="Алексей Сивко — бизнес-тренер"
              className="w-28 h-28 md:w-36 md:h-36 rounded-2xl object-cover"
            />
          </div>

          {/* Info */}
          <div className="flex-1 text-center md:text-left">
            <div className="flex flex-col md:flex-row md:items-center gap-2 md:gap-4 mb-4">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900">Алексей Сивко</h2>
              <span className="inline-block bg-teal-600 text-white text-xs font-semibold px-3 py-1 rounded-full">
                Автор статьи
              </span>
            </div>

            <p className="text-gray-600 mb-6 leading-relaxed text-sm md:text-base">
              Бизнес-тренер и консультант с более чем 18-летним опытом в корпоративном обучении. Провёл 100+ проектов для компаний из Беларуси, России, Казахстана и Израиля. 4500+ участников прошли обучение по программам BusinessTraining.by. Специализация: системное развитие персонала, обучение продажам, управленческие компетенции и бизнес-игры.
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-4 mb-6">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-teal-600">18+</div>
                <div className="text-xs text-gray-500 mt-1">лет опыта</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-teal-600">100+</div>
                <div className="text-xs text-gray-500 mt-1">проектов</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-teal-600">4500+</div>
                <div className="text-xs text-gray-500 mt-1">участников</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-extrabold text-teal-600">4</div>
                <div className="text-xs text-gray-500 mt-1">страны</div>
              </div>
            </div>

            <div className="flex items-center gap-3 justify-center md:justify-start flex-wrap">
              <a href="https://t.me/a_sivko" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors cursor-pointer">
                <i className="ri-telegram-line text-lg"></i> Telegram
              </a>
              <span className="text-gray-300">|</span>
              <a href="https://www.linkedin.com/in/alekseysivko" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-box-line text-lg"></i> LinkedIn
              </a>
              <span className="text-gray-300">|</span>
              <a href="https://businesstrainer.by/" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-1.5 text-sm font-medium text-teal-600 hover:text-teal-700 transition-colors cursor-pointer">
                <i className="ri-star-line text-lg"></i> Отзывы клиентов
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}